import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationOptions } from '../../notifications/utils/notification-builder';
import { Dispatch } from 'redux';
import { NotificationTypes } from '../../notifications';

const initialState: NotificationOptions[] = [];

const notifications = createSlice({
  name: 'app/notifications',
  initialState,
  reducers: {
    addNotification(state: NotificationOptions[], action: PayloadAction<NotificationOptions>) {
      if (action?.payload?.version === NotificationTypes.FLAG) {
        return [...state, action.payload];
      }
      return [action.payload, ...state];
    },
    dismissNotificationWithId(state: NotificationOptions[], action: PayloadAction<string>) {
      return state.filter((notification) => notification.id !== action.payload);
    },
    dismissOldestNotification(state: NotificationOptions[]) {
      return state.slice(0, state.length - 1);
    },
  },
});

export const { addNotification, dismissNotificationWithId, dismissOldestNotification } = notifications.actions;

export default notifications.reducer;

export const notificationsState = (state: any) => state.notification;

const getNotifications = createSelector(notificationsState, (state) => state);

export const createNotification = (notificationOptions: NotificationOptions): any => async (dispatch: Dispatch) => {
  dispatch(addNotification(notificationOptions));
  if (notificationOptions.dismissAfter) {
    setTimeout(() => {
      dispatch(dismissNotificationWithId(notificationOptions.id));
    }, notificationOptions.dismissAfter);
  }
};

export const notificationsSelectors = {
  getNotifications,
};
